import { SEARCH_STRING_MICROFRONTEND_NAME } from './constants';
import { ensureMicrofrontend } from '../../../utils/ensureMicrofrontend';

/** Останавливает перебор интентов в поисковой строке — навсегда до перезагрузки страницы */
export async function disablePlaceholders(): Promise<void> {
  const microfrontend = await ensureMicrofrontend(SEARCH_STRING_MICROFRONTEND_NAME);

  return microfrontend?.call('/v1/disable-placeholders');
}
